import React from 'react';

/**
 * UploadPrompt — The "Choose a file or drag and drop" message.
 *
 * Shown inside the FileUploader dropzone when no file is selected.
 * The "Choose a file" text is a clickable link that triggers the file picker.
 *
 * @param {func}   onSelect    - Opens the native file picker dialog
 * @param {string} hint        - Override the default "Supported formats: ..." text
 * @param {string} customClass - Additional CSS classes
 */
export const UploadPrompt = ({ onSelect, hint, customClass = "", customStyle = {} }) => {
    return (
        <div className={`upload-prompt ${customClass}`} style={customStyle}>
            <div className="upload-prompt-text body-l">
                <button
                    type="button"
                    className="upload-prompt-action link-default"
                    onClick={(e) => {
                        e.stopPropagation(); // Prevent double-triggering from parent click handler
                        onSelect?.(e);
                    }}
                >
                    Choose a file
                </button>
                <span className="upload-prompt-separator">or</span>
                <span className="upload-prompt-hint">drag and drop a file here.</span>
            </div>
            <div className="upload-prompt-formats body-s">
                {hint || "Supported formats: Excel (.xls, .xlsx) and .csv"}
            </div>
        </div>
    );
};

export default UploadPrompt;
